import React, { useContext } from "react";

import WeekTable from "../components/WeekTable";
import CustomLoader from "../components/CustomLoader";
import { AppContext } from "../providers/ContextProvider";
import { AlertContext } from "../providers/AlertProvider";
import ErrorMessage from "../components/ErrorMessage";

export default function TimeEntryTab() {
    const { user, token } = useContext(AppContext);
    const { errorMsg } = useContext(AlertContext);

    return (
        <>
            {!errorMsg && token ? (
                <div className="px-0 pt-2 pb-3 sm:p-4 lg:p-6 flex flex-col justify-start items-stretch min-h-full w-full max-w-full overflow-hidden box-border bg-(--theme-bg-1)">
                    {!user ? <CustomLoader msg="Fetching users" /> : <WeekTable token={token} user={user} />}
                </div>
            ) : errorMsg ? (
                <ErrorMessage errorMsg={errorMsg} />
            ) : (
                <CustomLoader msg="Signing in" />
            )}
        </>
    );
}
